// ** React Imports
import React from 'react'

// ** Source code Imports
import PrivacyPolicyRu from './privacy-policy-ru'

const PrivacyPolicy = () => {
  return <PrivacyPolicyRu />
}

export default PrivacyPolicy
